import React, { Component } from "react";
import { connect } from "react-redux";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import AddIcon from "material-ui/svg-icons/content/add-circle-outline";
import CloseIcon from "material-ui/svg-icons/navigation/close";
import IconButton from "material-ui/IconButton";
import AutoComplete from "material-ui/AutoComplete";
import Toggle from "material-ui/Toggle";

import { getKindPrimaryText } from "../utils";
import {
  loadResorts,
  loadChannels,
  selectResort,
  removePartner,
  selectPartner,
  addPartner,
  activatePartner,
  updatePartnershipChannels
} from "./actions";

import "./Partnership.css";

class Partnership extends Component {
  state = {
    search: ""
  };

  componentDidMount() {
    this.props.loadResorts();
    this.props.loadChannels();
  }

  handleChange = (event, index, value) => {
    this.props.selectResort(value);
  };

  deleteClick = (resort, code) => e => {
    this.props.removePartner(resort, code);
  };

  togglePartnership = (resort, code, active) => () => {
    this.props.activatePartner(resort, code, active);
  };

  handleUpdateChannels = (resort, partnership) => (e, key, value) => {
    this.props.updatePartnershipChannels(resort, partnership, value);
  };

  handleUpdateInput = (current, merchants) => {
    this.setState({
      search: current
    });
    const currentMerchant = merchants.find(x => x.libelle === current);
    currentMerchant
      ? this.props.selectPartner(currentMerchant.code)
      : this.props.selectPartner(undefined);
  };

  clearPartner = () => {
    this.setState({
      search: ""
    });
  };
  addPartner = (resort, merchant) => e => {
    this.props.addPartner(resort, merchant, this.clearPartner);
  };

  renderAddButton = (resort, merchant) => {
    if (!merchant) return null;
    const style = { width: "20px" };
    return (
      <IconButton iconStyle={style} onClick={this.addPartner(resort, merchant)}>
        <AddIcon />
      </IconButton>
    );
  };

  renderAddMerchant(resorts, merchants) {
    if (!resorts.selected) return null;
    const selected = resorts.byId[resorts.selected];
    const selectables = merchants.all
      .filter(x => merchants.selecteds.indexOf(x) < 0)
      .map(x => merchants.byId[x])
      .map(x => {
        return {
          ...x,
          libelle: x.code.concat(
            " : ",
            x.libelle.replace("Remontées Mécaniques", "RM")
          )
        };
      });
    return (
      <div className="card">
        <div className="title--container">
          <div className="title">
            Ajout d'un partenariat pour {selected.libelle}
          </div>
        </div>
        <div className="inner">
          <AutoComplete
            listStyle={{ width: "500px", maxHeight: "200px", overflow: "auto" }}
            floatingLabelText="Recherche de marchand"
            openOnFocus={true}
            searchText={this.state.search}
            filter={AutoComplete.caseInsensitiveFilter}
            onUpdateInput={this.handleUpdateInput}
            dataSource={selectables}
            dataSourceConfig={{ text: "libelle", value: "code" }}
          />
          {this.renderAddButton(resorts.selected, merchants.selection)}
        </div>
      </div>
    );
  }

  renderPartnerList(resort, merchants) {
    const style = { width: "20px" };
    const { channels } = this.props;
    const partners = merchants.selecteds.map(x => {
      return {
        ...merchants.byId[x.code],
        active: x.active === 1,
        id: x.id,
        channels: x.channels
      };
    });
    return partners.length === 0 ? (
      <div className="inner">Aucun partenaire</div>
    ) : (
      <table>
        <thead>
          <tr>
            <th className="col0">Nom</th>
            <th className="col1">Type</th>
            <th className="col2">Actif</th>
            <th className="col4">Canaux</th>
            <th className="selector" />
          </tr>
        </thead>
        <tbody>
          {partners.map(partner => {
            return (
              <tr key={partner.code}>
                <td className="col0">{partner.libelle}</td>
                <td className="col1">{getKindPrimaryText(partner.kind)}</td>
                <td className="col2">
                  <span
                    onClick={this.togglePartnership(
                      resort,
                      partner.code,
                      !partner.active
                    )}
                  >
                    <Toggle
                      className="activate-partnership-toggle"
                      toggled={partner.active}
                    />
                  </span>
                </td>
                <td className="col4">
                  <SelectField
                    value={partner.channels}
                    onChange={this.handleUpdateChannels(resort, partner.id)}
                    menuStyle={{ width: "200px" }}
                    selectedMenuItemStyle={{
                      color: "initial"
                    }}
                    multiple
                    selectionRenderer={value =>
                      value && value.length > 1
                        ? `${value.length} canaux de vente`
                        : value
                    }
                  >
                    {channels.map(channel => {
                      return (
                        <MenuItem
                          className="channel-item"
                          key={channel.code}
                          value={channel.code}
                          primaryText={channel.name}
                          checked={
                            partner.channels &&
                            partner.channels.indexOf(channel.code) >= 0
                          }
                        />
                      );
                    })}
                  </SelectField>
                </td>
                <td className="selector">
                  <IconButton
                    iconStyle={style}
                    onClick={this.deleteClick(resort, partner.code)}
                  >
                    <CloseIcon />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderStation(resorts, merchants) {
    if (!resorts.selected) return null;
    const selected = resorts.byId[resorts.selected];
    return (
      <div className="list card partner">
        <div className="title--container">
          <div className="title">
            Liste des partenariats pour {selected.libelle}
          </div>
        </div>
        {this.renderPartnerList(selected.id, merchants)}
      </div>
    );
  }

  render() {
    const resorts = this.props.resorts.list;
    const resortSelected = resorts.selected;
    const merchants = this.props.merchants.list;
    return !resorts.all || resorts.all.isEmpty ? null : (
      <div className="card-container partnership">
        <div className="card">
          <div className="title">Gestion des partenariats</div>
          <div className="inner">
            <SelectField
              floatingLabelText="Station"
              value={resortSelected}
              onChange={this.handleChange}
            >
              <MenuItem value={null} primaryText="" />
              {resorts.all.map(resort => {
                const { id, libelle } = resorts.byId[resort];
                return <MenuItem key={id} value={id} primaryText={libelle} />;
              })}
            </SelectField>
          </div>
        </div>
        {this.renderStation(resorts, merchants)}
        {this.renderAddMerchant(resorts, merchants)}
      </div>
    );
  }
}

/********* Container part */

const mapStateToProps = state => ({
  resorts: state.partnership.resorts,
  merchants: state.partnership.merchants,
  channels: state.partnership.channels
});

const mapDispatchToProps = dispatch => {
  return {
    loadResorts: () => dispatch(loadResorts()),
    loadChannels: () => dispatch(loadChannels()),
    selectResort: id => dispatch(selectResort(id)),
    removePartner: (resort, merchant) =>
      dispatch(removePartner(resort, merchant)),
    selectPartner: partner => dispatch(selectPartner(partner)),
    addPartner: (resort, partner, cb) =>
      dispatch(addPartner(resort, partner, cb)),
    activatePartner: (resort, partner, active) =>
      dispatch(activatePartner(resort, partner, active)),
    updatePartnershipChannels: (resort, partnership, channels) =>
      dispatch(updatePartnershipChannels(resort, partnership, channels))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Partnership);



// WEBPACK FOOTER //
// ./src/partnership/Partnership.js